import { PARTNER_PROFILE } from '@utils/constants';
import { useIsDirectoryPageEnabled } from '@utils/useIsDirectoryPageEnabled';
import { buildPartnersProfileUrl } from '@utils/partnersDirectoryPaths';

export function usePartnersProfileUrl() {
  const useCommunitySubdomain = useIsDirectoryPageEnabled();
  return (args: { host: string; slug: string; pathLanguage?: string | null }) =>
    buildPartnersProfileUrl({ ...args, useCommunitySubdomain });
}

export function usePartnersProfilePath(): string {
  const useCommunitySubdomain = useIsDirectoryPageEnabled();
  return useCommunitySubdomain ? '/partners' : `/${PARTNER_PROFILE}`;
}
